import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import Button from '../Button';
import ButtonLink from '../ButtonLink';

export type BtnVariant =
    | 'primary'
    | 'primaryLight'
    | 'primaryLightBordered'
    | 'secondary'
    | 'secondaryLight'
    | 'secondaryLightBordered'
    | 'tertiary'
    | 'delete'
    | 'deleteLight'
    | 'deleteLightBordered';
interface Props {
    children: React.ReactNode;
    btnClassName?: any;
    onMouseDown?: (param: any) => void;
    onClick?: (param: any) => void;
    variant?: BtnVariant;
    size?: string;
    type?: 'button' | 'submit' | 'reset';
    isDisabled?: boolean;
    icon?: IconProp;
    name?: string;
    link?: string;
    className?: any;
    onDoubleClick?: (param: any) => void;
    value?: string;
    role?: string;
    tabIndex?: number;
}

function ButtonVariant(props: Props) {
    const {
        link,
        btnClassName,
        variant = 'primary',
        size,
        type,
        onClick,
        onMouseDown,
        isDisabled,
        children,
        icon,
        name,
        role,
        tabIndex,
    } = props;
    return (
        <>
            {link ? (
                <ButtonLink
                    className={btnClassName}
                    onClick={onClick}
                    variant={variant}
                    size={size}
                    type={type}
                    icon={icon}
                    link={link}
                    role={role}
                    tabIndex={tabIndex}
                >
                    {children}
                </ButtonLink>
            ) : (
                <Button
                    className={btnClassName}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    variant={variant}
                    size={size}
                    type={type}
                    isDisabled={isDisabled}
                    icon={icon}
                    name={name}
                    role={role}
                    tabIndex={tabIndex}
                >
                    {children}
                </Button>
            )}
        </>
    );
}

export default ButtonVariant;
